// extracted by mini-css-extract-plugin
export default {"offerContainer":"GlobalOffer_offerContainer__h9ZXO"};